/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PutUserGeolocConsentsRequestDto } from '../../models/put-user-geoloc-consents-request-dto';

export interface UpdateGeolocConsents$Params {
  body: PutUserGeolocConsentsRequestDto;
}

export function updateGeolocConsents(
  http: HttpClient,
  rootUrl: string,
  params: UpdateGeolocConsents$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<{}>> {
  const rb = new RequestBuilder(rootUrl, updateGeolocConsents.PATH, 'put');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{}>;
    })
  );
}

updateGeolocConsents.PATH = '/v2/users/consents';
